import { Props_SnippetContent } from './Content.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''
    const classHeadingAlignment: string = heading.textAlignment?.value ? `snippet-content__heading--${heading.textAlignment.value}` : ''
    const paragraphAlignment: string = paragraph.textAlignment?.value ? `snippet-content__content--${paragraph.textAlignment.value}` : ''

    return (
        <section className="snippet-content" id={heading?.snippetid?.value || ''}>
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility} ${classHeadingAlignment}`}>{heading?.content?.value}</h2>
                <div className={"snippet-content__content " + paragraphAlignment}>
                    {paragraph.text.value && CompileMarkdown(paragraph?.text?.value)}
                </div>
                <div className="snippet-content__link-container">
                    {repeatable_link.map((link, index) => (
                        (link.linkHref?.value && link.linkText?.value && <a key={index}
                            className="snippet-content__link"
                            href={link.linkHref?.value}
                            target={link.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                            rel={link.openInNewTab?.value === 'true' ? 'noopener noreferrer' : undefined}>
                            {link.linkText?.value}
                        </a>)
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetContent
